<template>
  <v-dialog
    v-model="model"
    :max-width="maxWidth ? maxWidth : !tabletAndMobile ? 'calc(100% - 12vw)' : ''"
    :persistent="persistent"
  >
    <img
      v-if="$slots.default"
      class="close-btn"
      src="@/assets/imgs/common/X.png"
      @click="$emit('update:modelValue', false)"
    />
    <div ref="dialogHoverElement" class="dialog-frame">
      <slot name="default">
        <div class="text-dialog pa-8">
          <i-local-close
            v-if="showCloseBtn"
            class="close-btn mt-4 mr-4"
            style="color: #fea922"
            @click="$emit('update:modelValue', false)"
          />
          <StyledTitle v-if="title" :align="tabletAndMobile ? 'left' : 'center'" class="dialog-title pb-8 px-10">{{
            title
          }}</StyledTitle>
          <div class="dialog-body px-lg-5 px-3">
            <slot name="body" />
          </div>
          <div v-if="$slots.footer" class="dialog-footer pt-8">
            <slot name="footer" />
          </div>
        </div>
      </slot>
      <Transition v-if="navBtns.navPrev" name="fade">
        <div v-show="isHovering || tabletAndMobile" class="nav-btn" @click.stop="navBtns.navPrev">
          <i-local-home-banner-arrow />
        </div>
      </Transition>
      <Transition v-if="navBtns.navNext" name="fade">
        <div v-show="isHovering || tabletAndMobile" class="nav-btn right" @click.stop="navBtns.navNext">
          <i-local-home-banner-arrow />
        </div>
      </Transition>
    </div>
  </v-dialog>
</template>
<script setup lang="ts">
  import { useElementHover } from '@vueuse/core'

  defineProps({
    title: {
      type: String,
      default: '',
    },
    navBtns: {
      type: Object,
      default: () => ({}),
    },
    maxWidth: {
      type: String,
      default: '',
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    showCloseBtn: {
      type: Boolean,
      default: true,
    },
  })

  const model = defineModel({ default: false })
  const { smAndDown: tabletAndMobile } = useDisplay()

  defineEmits(['update:modelValue'])

  const dialogHoverElement = ref()
  const isHovering = useElementHover(dialogHoverElement)
  watchEffect(() => {
    document.documentElement.style.overflowY = model.value ? 'hidden' : 'auto'
  })
</script>
<style lang="scss" scoped>
  .dialog-frame {
    border-radius: 10px;
    overflow: hidden;
    z-index: 1; // for getting mouse event by same z-index with nav-btns
    max-height: calc(100vh - 100px);
    margin: 0 auto;
  }

  .text-dialog {
    display: flex;
    flex-direction: column;
    overflow-wrap: break-word;
    position: relative;
    background-color: var(--dialog-bg-color);
    font-size: 16px;
    color: var(--dialog-text-color);
    max-height: inherit;

    .dialog-body {
      text-align: center;
      line-height: 2em;
      overflow-y: auto;
    }
  }
  :deep(.dialog-title) {
    span {
      white-space: inherit;
    }
  }
  @media #{$pcOnly} {
    :deep(.dialog-title) {
      .line {
        max-width: 10vw;
      }
    }
  }

  .nav-btn {
    position: absolute;
    top: 50%;
    transform: translate(10%, -50%);
    display: inline-flex;
    justify-content: center;
    align-items: center;
    user-select: none;
    width: 62px;
    aspect-ratio: 1/1;
    border: 2px solid white;
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 32px;
    z-index: 2;
    cursor: pointer;
    color: white;
    left: 0;
    svg {
      width: 22px;
    }
    path {
      // fill: white;
      transition: all 0.2s;
    }
    &:active {
      color: #ffb72d;
    }

    @media (hover: hover) {
      &:hover {
        color: #ffb72d;
      }
    }
    &.right {
      left: initial;
      right: 0;
      transform: translate(-10%, -50%) scaleX(-1);
    }
  }

  .close-btn {
    position: absolute;
    cursor: pointer;
    right: 0;
    top: -40px;
    opacity: 0.7;
    transition: opacity 0.2s;
    &:hover {
      opacity: 1;
    }
  }
  .text-dialog {
    .close-btn {
      top: 0;
    }
  }

  @media #{$tablet} {
    // .dialog-frame {
    //   backdrop-filter: blur(15px);
    // background-color: rgba(0, 0, 0, 0.75);
    // box-shadow: 0px 4px 5px -2px rgba(0, 0, 0, 0.2), 0px 7px 10px 1px rgba(0, 0, 0, 0.14), 0px 2px 16px 1px rgba(0, 0, 0, 0.12);
    // }
    .nav-btn {
      width: 52px;
      svg {
        width: 16px;
      }
    }
  }

  @media #{$mobile} {
    .nav-btn {
      width: 40px;
      height: 40px;
    }
  }
  // @media (min-aspect-ratio: 16/9) {
  //   .dialog-frame {
  //     height: 80vh;
  //   }
  // }
</style>
